<template>
  <header class="bg-white/50 backdrop-blur-md border-b border-gray-200 fixed w-full z-50 transition-all duration-300">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between items-center h-20">
        <div class="flex-shrink-0 flex items-center group">
          <router-link to="/" class="flex items-center gap-2">
            <div class="w-15 h-15 bg-gradient-to-br from-red-400 to-red-600 rounded-xl flex items-center justify-center shadow-lg group-hover:rotate-12 transition-transform">
              <span class="text-slate-950 font-black text-xl">
                <a href="/">
            <img alt="Logo" class="h-10 w-auto" :src="logo" />
          </a>
              </span>
            </div>
            <span class="text-4xl font-white tracking-tighter text-red-600">Secrable</span>
          </router-link>
        </div>

        <!-- Desktop Navigation -->
        <nav class="hidden md:flex items-center space-x-1">
          <router-link
            v-for="link in navLinks"
            :key="link.path"
            :to="link.path"
            class="text-gray-700 hover:text-red-600 px-4 py-2 text-sm font-bold transition-all hover:bg-red-50 rounded-xl"
            active-class="text-red-600 bg-red-500/10"
          >
            {{ link.name }}
          </router-link>
          
          <router-link
            to="/LoginPage"
            class="ml-4 px-6 py-2.5 bg-red-600 text-white text-sm font-black rounded-xl hover:bg-red-500 transition-colors shadow-[0_0_15px_rgba(239,68,68,0.2)]"
          >
            Login
          </router-link>
        </nav>

        <!-- Mobile Menu Button -->
        <div class="md:hidden flex items-center">
          <button
            @click="toggleMobileMenu"
            class="text-gray-700 hover:text-red-600 w-12 h-12 flex items-center justify-center transition-colors rounded-xl bg-gray-100"
          >
            <Menu v-if="!isMobileMenuOpen" class="h-6 w-6" />
            <X v-else class="h-6 w-6" />
          </button>
        </div>
      </div>

      <!-- Mobile Navigation Menu -->
      <transition 
        enter-active-class="transition duration-200 ease-out" 
        enter-from-class="transform opacity-0 scale-95" 
        enter-to-class="transform opacity-100 scale-100" 
        leave-active-class="transition duration-100 ease-in" 
        leave-from-class="transform opacity-100 scale-100" 
        leave-to-class="transform opacity-0 scale-95"
      >
        <div v-show="isMobileMenuOpen" class="md:hidden absolute top-20 left-0 w-full bg-white/95 backdrop-blur-xl border-b border-gray-200 pb-8 px-4">
          <div class="flex flex-col space-y-2 pt-4">
            <router-link
              v-for="link in navLinks"
              :key="link.path"
              :to="link.path"
              @click="isMobileMenuOpen = false"
              class="text-gray-700 hover:text-red-600 block px-4 py-4 text-lg font-bold transition-colors border-b border-gray-200 last:border-none"
              active-class="text-red-600 bg-red-500/5"
            >
              {{ link.name }}
            </router-link>
            <router-link
              to="/LoginPage"
              @click="isMobileMenuOpen = false"
              class="mt-4 w-full py-4 bg-red-600 text-white text-center font-black rounded-2xl shadow-lg"
            >
              Login
            </router-link>
          </div>
        </div>
      </transition>
    </div>
  </header>
</template>

<script setup>
import logo from "@/assets/logo.png";

import { ref } from "vue";
import { Menu, X } from "lucide-vue-next";

const isMobileMenuOpen = ref(false);

const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/About" },
  { name: "Contact", path: "/ContactUs" },

];

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value;
};
</script>
